import PeCompanyDataView from 'presentation/components/modules/pe/shared/detail/PeCompanyDataView';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useFetchPeCompanyDetailQuery } from 'rtkQuery/sharespro/queries/peService';

const PeCompanyDetailPage: FC = () => {
  const { id } = useParams();
  const assetId = +(id as string);
  const { isFetching, data, refetch, error } = useFetchPeCompanyDetailQuery({
    id: assetId,
  });

  return (
    <PeCompanyDataView
      data={data}
      assetId={assetId}
      refetch={() => {
        refetch();
      }}
      error={error}
      isFetching={isFetching}
    />
  );
};

export default PeCompanyDetailPage;
